import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';

@Injectable()
export class RunEventsService {
    @LocalStorage() url: Url;

  	private headers = new Headers({ 'Content-Type': 'application/json' });
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    } 

    constructor(public http:HttpClient) {
    }

	getRunEvents(run_id:number): Observable<any> { 
        return this.http.get<any>(this.url.rest + '/tms/getRunEventsByRunId/' + run_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }


    updateRunEvents(run_event :any): Observable<any> {
        return this.http.post<any>(this.url.rest + '/tms/updateRunEvent', run_event , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    
    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
   
}